import FlooringHero from './components/FlooringHero';
import FlooringServices from './components/FlooringServices';
import FlooringTypesElPaso from './components/FlooringTypesElPaso';
import ComparisonChecklist from './components/ComparisonChecklist';
import FlooringFAQ from './components/FlooringFAQ';
import ContractorDirectory from './components/ContractorDirectory';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useEffect } from 'react';

export default function Flooring() {
  useEffect(() => {
    document.title = 'Flooring Contractors El Paso | Hardwood, Tile, Carpet & LVP Installation';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Find expert flooring contractors in El Paso for hardwood, tile, carpet, and luxury vinyl plank installation. Get free quotes from licensed professionals.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'flooring contractors El Paso, hardwood flooring, tile installation, carpet installation, luxury vinyl plank');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FlooringHero />
      <FlooringServices />
      <FlooringTypesElPaso />
      <ComparisonChecklist />
      <FlooringFAQ />
      <ContractorDirectory />
      <Footer />
    </div>
  );
}
